import React from 'react'
import { Link } from 'react-router'
import { Container, Row, Col, Button, InputGroup, InputGroupAddon, Input, Label, FormGroup } from 'reactstrap';

import FirstStatusChoices from './status/FirstStatusChoices'
import SecondStatusChoices from './status/SecondStatusChoices'
import NetworkChoice from './status/NetworkChoice'
import RefusalChoice from './status/RefusalChoice'
import MeetingChoice from './status/MeetingChoice'

import Loader from '../../core/components/Loader'

class UpdateProviderStatus extends React.Component {

	constructor(props) {
	  super(props);
	
	  this.state = {
	  	 choice:null
	  };
	}

	componentDidMount() {
		if(!this.props.provider.fulfilled)
			this.props.retrieveProvider(this.props.params.provider_id)
	}

	onClose(){
		this.props.onClose(this.props.params.provider_id)
	}

	onBack(){
		this.setState({choice:null})
	}

	onChangeChoices(choice){
		this.setState({choice})
	}

	onAccepted(network){
		this.props.acceptedProvider(this.props.params.provider_id, network)
	}

	onStandBy(network){
		this.props.standByProvider(this.props.params.provider_id, network)
	}

	onRefusal(network){
		this.props.refusalProvider(this.props.params.provider_id, network)
	}

	meetingProvider(rdv){
		this.props.meetingProvider(this.props.params.provider_id, rdv)
	}


	onSecondChangeChoices(choice){

		if(choice == "RV" || choice == "R")
			this.setState({choice})

		if(choice == "W")
			this.props.standByProvider(this.props.params.provider_id, null)

		if(choice == "A")
			this.props.approvedProvider(this.props.params.provider_id)

	}


	renderChoices(){
		const { provider, status } = this.props

		if (provider.provider.status == "CA" || provider.provider.status == "PA" || provider.provider.status == "A" || provider.provider.status == "W" || provider.provider.status == "R" ){
			if(!this.state.choice)
				return <FirstStatusChoices provider={provider.provider} onChangeChoices={this.onChangeChoices.bind(this)} onClose={this.onClose.bind(this)}/>

			if(this.state.choice == "A")
				return <NetworkChoice provider={provider.provider} status={status} onSubmit={this.onAccepted.bind(this)} onClose={this.onClose.bind(this)} onBack={this.onBack.bind(this)} />

			if(this.state.choice == "W")
				return <NetworkChoice provider={provider.provider} status={status} onSubmit={this.onStandBy.bind(this)} onClose={this.onClose.bind(this)} onBack={this.onBack.bind(this)}/>

			if(this.state.choice == "R")
				return <RefusalChoice provider={provider.provider} status={status} onSubmit={this.onRefusal.bind(this)} onClose={this.onClose.bind(this)} onBack={this.onBack.bind(this)}/>
		}

		if(provider.provider.status == "RV"){
			if(!this.state.choice)
				return <SecondStatusChoices provider={provider.provider} status={status} onSecondChangeChoices={this.onSecondChangeChoices.bind(this)} onClose={this.onClose.bind(this)}/>

			if(this.state.choice == "R")
				return <RefusalChoice provider={provider.provider} status={status} onSubmit={this.onRefusal.bind(this)} onClose={this.onClose.bind(this)} onBack={this.onBack.bind(this)}/>

			if(this.state.choice == "RV")
				return <MeetingChoice provider={provider.provider} status={status} onSubmit={this.meetingProvider.bind(this)} onClose={this.onClose.bind(this)} onBack={this.onBack.bind(this)}/>
		}


	}

	render(){
		const { provider } = this.props

		return(
			<div>
				{provider.fulfilled &&
					this.renderChoices()
				}

				{provider.pending &&
					<Loader />
				}

				{provider.error &&
					<div> Erreur </div>
				}
			</div>
		)
	}
}


export default UpdateProviderStatus


// WEBPACK FOOTER //
// ./src/provider/components/UpdateProviderStatus.js